import React from "react";
import Products from "../Components/Products/Products.component";
import Footer from "../Components/Footer/Footer.component";
import Contact from "../Components/Contact/Contact.component";
import "./ShopPage.css";

function ShopPage() {
  return (
    <>
      <div className="shop-temp-top" id="card"></div>
      <div className="shop">
        <Products />
        <Contact />
        <Footer />
      </div>
    </>
  );
}

export default ShopPage;
